import { extentionByFileType } from 'constants/fileTypes';

export const extractFileNameAndExtension = (
  fileName: string
): { name: string; extension: string } => {
  const extension = fileName.split('.').pop()?.toLowerCase() || '';
  const isAllowedExtension = Object.values(extentionByFileType).includes(
    extension as keyof typeof extentionByFileType
  );

  if (isAllowedExtension) {
    return {
      name: fileName.split('.').slice(0, -1).join('.'),
      extension,
    };
  }

  return { name: fileName, extension: '' };
};
